export function LoopIcon({
  color,
  h = 14,
  w = 14,
}: {
  color?: string;
  h?: string | number;
  w?: string | number;
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={w} height={h} viewBox="0 0 14 14" fill="none">
      <path
        d="M12.6875 11.7031L9.29469 8.30977C9.84146 7.5584 10.1356 6.65285 10.1347 5.72359C10.1347 3.29137 8.15582 1.3125 5.72359 1.3125C3.29137 1.3125 1.3125 3.29137 1.3125 5.72359C1.3125 8.15582 3.29137 10.1347 5.72359 10.1347C6.65285 10.1356 7.5584 9.84146 8.30977 9.29469L11.7031 12.6875L12.6875 11.7031ZM5.72359 8.74152C5.12663 8.74158 4.54305 8.5646 4.04667 8.23298C3.55028 7.90136 3.16339 7.42998 2.93492 6.87846C2.70644 6.32695 2.64665 5.72006 2.7631 5.13457C2.87955 4.54907 3.16701 4.01125 3.58913 3.58913C4.01125 3.16701 4.54907 2.87955 5.13457 2.7631C5.72006 2.64665 6.32695 2.70644 6.87846 2.93492C7.42998 3.16339 7.90136 3.55028 8.23298 4.04667C8.5646 4.54305 8.74158 5.12663 8.74152 5.72359C8.74058 6.52371 8.42232 7.29079 7.85655 7.85655C7.29079 8.42232 6.52371 8.74058 5.72359 8.74152Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
